export default {
    setConnectedAccounts(state, payload) {
        state.connectedTikTokAccounts = payload;
    },
    setClientDetails(state, payload) {
        state.authUrl = payload;
    }
}